import axios from 'axios'
import urlHelper from './urlHelper'

const baseUrl = urlHelper('/api/userpageelement')

export default {
  getList () {
    return axios.get(baseUrl)
  },
  byPage (pageNumber) {
    return axios.get(`${baseUrl}/byPage/${pageNumber}`)
  },
  add (pageNumber, type, el) {
    return axios.post(baseUrl, { type, pageNumber, element: el })
  },
  delete (id) {
    return axios.delete(`${baseUrl}/${id}`)
  },
  deleteByPageNumber (pageNumber) {
    return axios.delete(`${baseUrl}/deleteByPageNumber/${pageNumber}`)
  }
}
